import "./_lineInfo.scss";

import cx from "classnames";

function LineInfo({
  label,
  value,
  type,
  size = "normal",
  onChange = () => {},
}: {
  label?: string | null;
  value?: string | null;
  size?: "normal" | "large";
  type?: "adresse" | "input" | null;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}): JSX.Element | undefined {
  if (label && value) {
    let content = (
      <>
        <p className="lineInfo-label">{label}</p>
        <p className="lineInfo-value">{value}</p>
      </>
    );

    if (type === "input") {
      content = (
        <>
          <label className="lineInfo-label">{label + " : "}</label>{" "}
          <input
            className="lineInfo-value"
            type="text"
            placeholder={label}
            onChange={e => {
              onChange(e);
            }}
            value={value}
          />
        </>
      );
    }
    return <div className={cx("lineInfo", size, type)}>{content}</div>;
  }
}

export default LineInfo;
